import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { INewLoginResponse } from '../models/response/login.response';

export interface IUser {
  email: string;
  password: string;
  remember?: boolean;
  response?: INewLoginResponse;
}

@Injectable({
  providedIn: 'root'
})
export class SendDataService {
  userSubject: BehaviorSubject<IUser> = new BehaviorSubject(null);
  user$: Observable<IUser> = this.userSubject.asObservable();

  setUser(user: IUser) {
    this.userSubject.next(user);
  }
}
